import React from "react";

export default React.memo(
  ({
    token,
    refreshtoken,
    children,
    text,
    image,
    appSelectorAlternativeUrl,
    language,
    ...rest
  }) => {
    // console.log(appSelectorAlternativeUrl,'appSelectorAlternativeUrl');
    const separator = "||||||";
    const path = "auth/bytoken/";
    const href =
      appSelectorAlternativeUrl +
      (token && refreshtoken ? path + token + separator + refreshtoken : "") + '?language=' + language;

    return (
      <a {...rest} href={href}>
        {children}
        {/* {text ? " massphoning-out" : <img alt="Massphoning" src={image} />} */}
        {text ? " easycall-out" : <img alt="Massphoning" src={image} />}
      </a>
    );
  }
);
